import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BackendHealthService {
  private readonly unhealthyCall$$ = new Subject<void>();
  readonly unhealthyBackend$ = this.unhealthyCall$$.asObservable();

  reportUnhealthyCall() {
    this.unhealthyCall$$.next();
  }
}
